import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { configProviderInjectionKey as c } from "./context.js";
import D from "../../../../../../lodash-es@4.17.21/node_modules/lodash-es/merge.js";
import v from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { defaultClsPrefix as g } from "../../_mixins/use-config.js";
import { markRaw as h } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import b from "../../../../../../@emotion_hash@0.8.0/node_modules/@emotion/hash/dist/hash.browser.esm.js";
import { warn as S } from "../../_utils/naive/warn.js";
import { defineComponent as C, inject as B, computed as d, provide as k, h as N } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const L = {
  abstract: Boolean,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clsPrefix: String,
  locale: Object,
  dateLocale: Object,
  namespace: String,
  rtl: Array,
  tag: {
    type: String,
    default: "div"
  },
  hljs: Object,
  katex: Object,
  theme: Object,
  themeOverrides: Object,
  componentOptions: Object,
  icons: Object,
  breakpoints: Object,
  preflightStyleDisabled: Boolean,
  styleMountTarget: Object,
  inlineThemeDisabled: {
    type: Boolean,
    default: void 0
  },
  // deprecated
  as: {
    type: String,
    validator: () => (S("config-provider", "`as` is deprecated, please use `tag` instead."), !0),
    default: void 0
  }
}, J = C({
  name: "ConfigProvider",
  alias: ["App"],
  props: L,
  setup(r) {
    const e = B(c, null), a = d(() => {
      const {
        theme: n
      } = r;
      if (n === null)
        return;
      const t = e == null ? void 0 : e.mergedThemeRef.value;
      return n === void 0 ? t : t === void 0 ? n : Object.assign({}, t, n);
    }), i = d(() => {
      const {
        themeOverrides: n
      } = r;
      if (n !== null) {
        if (n === void 0)
          return e == null ? void 0 : e.mergedThemeOverridesRef.value;
        {
          const t = e == null ? void 0 : e.mergedThemeOverridesRef.value;
          return t === void 0 ? n : D({}, t, n);
        }
      }
    }), s = v(() => {
      const {
        namespace: n
      } = r;
      return n === void 0 ? e == null ? void 0 : e.mergedNamespaceRef.value : n;
    }), f = v(() => {
      const {
        bordered: n
      } = r;
      return n === void 0 ? e == null ? void 0 : e.mergedBorderedRef.value : n;
    }), R = d(() => {
      const {
        icons: n
      } = r;
      return n === void 0 ? e == null ? void 0 : e.mergedIconsRef.value : n;
    }), O = d(() => {
      const {
        componentOptions: n
      } = r;
      return n !== void 0 ? n : e == null ? void 0 : e.mergedComponentPropsRef.value;
    }), m = d(() => {
      const {
        clsPrefix: n
      } = r;
      return n !== void 0 ? n : e ? e.mergedClsPrefixRef.value : g;
    }), T = d(() => {
      var n;
      const {
        rtl: t
      } = r;
      if (t === void 0)
        return e == null ? void 0 : e.mergedRtlRef.value;
      const l = {};
      for (const o of t)
        l[o.name] = h(o), (n = o.peers) === null || n === void 0 || n.forEach((u) => {
          u.name in l || (l[u.name] = h(u));
        });
      return l;
    }), j = d(() => r.breakpoints || (e == null ? void 0 : e.mergedBreakpointsRef.value)), p = r.inlineThemeDisabled || (e == null ? void 0 : e.inlineThemeDisabled), y = r.preflightStyleDisabled || (e == null ? void 0 : e.preflightStyleDisabled), P = r.styleMountTarget || (e == null ? void 0 : e.styleMountTarget), x = d(() => {
      const {
        value: n
      } = a, {
        value: t
      } = i, l = t && Object.keys(t).length !== 0, o = n == null ? void 0 : n.name;
      return o ? l ? `${o}-${b(JSON.stringify(i.value))}` : o : l ? b(JSON.stringify(i.value)) : "";
    });
    return k(c, {
      mergedThemeHashRef: x,
      mergedBreakpointsRef: j,
      mergedRtlRef: T,
      mergedIconsRef: R,
      mergedComponentPropsRef: O,
      mergedBorderedRef: f,
      mergedNamespaceRef: s,
      mergedClsPrefixRef: m,
      mergedLocaleRef: d(() => {
        const {
          locale: n
        } = r;
        if (n !== null)
          return n === void 0 ? e == null ? void 0 : e.mergedLocaleRef.value : n;
      }),
      mergedDateLocaleRef: d(() => {
        const {
          dateLocale: n
        } = r;
        if (n !== null)
          return n === void 0 ? e == null ? void 0 : e.mergedDateLocaleRef.value : n;
      }),
      mergedHljsRef: d(() => {
        const {
          hljs: n
        } = r;
        return n === void 0 ? e == null ? void 0 : e.mergedHljsRef.value : n;
      }),
      mergedKatexRef: d(() => {
        const {
          katex: n
        } = r;
        return n === void 0 ? e == null ? void 0 : e.mergedKatexRef.value : n;
      }),
      mergedThemeRef: a,
      mergedThemeOverridesRef: i,
      inlineThemeDisabled: p || !1,
      preflightStyleDisabled: y || !1,
      styleMountTarget: P
    }), {
      mergedClsPrefix: m,
      mergedBordered: f,
      mergedNamespace: s,
      mergedTheme: a,
      mergedThemeOverrides: i
    };
  },
  render() {
    var r, e, a, i;
    return this.abstract ? (i = (a = this.$slots).default) === null || i === void 0 ? void 0 : i.call(a) : N(this.as || this.tag, {
      class: `${this.mergedClsPrefix || g}-config-provider`
    }, (e = (r = this.$slots).default) === null || e === void 0 ? void 0 : e.call(r));
  }
});
export {
  L as configProviderProps,
  J as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/config-provider/src/ConfigProvider.js
// module id = 41
// module chunks = 67